import { ConfiguredServiceFormPage } from "./ConfiguredServiceFormPage";
import { partnerReferralFormConfig } from "./configuredServiceForms";

export function PartnerReferralFormPage() {
  return <ConfiguredServiceFormPage config={partnerReferralFormConfig} />;
}
